import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import { navigate, openDialog, setSaveState } from '../../actions';
import { updateDetallesMaquinaDB, NewMaquinaDB } from '../../actions/maquina_detalle_actions';

const styles = theme => ({
    buttonsBottom: {
        margin: '20px 15px 30px 8px',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
});


class MaquinaActionButtons extends Component {

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, 'save_maquina:detalles_error', false, 'sm');

    };


    checkFields = maquina => {

        if (maquina.fechaCompra < '1900-01-01T00:00:00') {
            this.messageDialog('Fecha de compra inválida');
            return false;
        } else if (!maquina.fechaCompra) {
            this.messageDialog('Fecha de compra inválida');
            return false;
        } else if (maquina.fechaBaja && Date.parse(maquina.fechaCompra) > Date.parse(maquina.fechaBaja)) {
            this.messageDialog('Fecha de baja debe ser posterior a la de compra');
            return false;
        } else if (Date.parse(maquina.fechaAlta.slice(0, 10)) < Date.parse(maquina.fechaCompra.slice(0, 10))) {
            this.messageDialog('La fecha de alta no puede ser anterior a la fecha de compra');
            return false;
        } else if (!maquina.descr) {
            this.messageDialog('Por favor, rellene el campo Nombre');
            return false;
        } else if (!maquina.matricula) {
            this.messageDialog('Por favor, rellene el campo Matrícula');
            return false;
        } else if (!maquina.fechaCompra) {
            this.messageDialog('Por favor, rellene el campo Fecha Compra');
            return false;
        } else if (!maquina.regInterno) {
            this.messageDialog('Por favor, rellene el campo Reg Interno');
            return false;
        }


        let fechasCorrectas = true;

        this.props.maquinaCentros.maquinaCentros.forEach((c, i) => {

            if (this.props.maquinaCentros.maquinaCentros[i + 1] !== undefined) {

                if (c.fEnd === null) {
                    this.messageDialog('Fechas de alta en centros incorrectas');
                    fechasCorrectas = false;
                }

                if (Date.parse(c.fEnd.slice(0, 10)) > Date.parse(this.props.maquinaCentros.maquinaCentros[i + 1].fIni.slice(0, 10))) {
                    this.messageDialog('Fechas de alta en centros incorrectas');
                    fechasCorrectas = false;
                }
            }

        });

        if (!fechasCorrectas) return false;

        return true;

    };

    updateHandler = () => {

        this.props.maquinaContadores.maquinaContadores.forEach(p => {
            if (typeof p.id !== 'number') p.id = -1;
        });

        this.props.maquinaIncidencias.maquinaIncidencias.forEach(p => {
            if (typeof p.id !== 'number') p.id = -1;
        });

        this.props.maquinalicencias.maquinalicencias.forEach(p => {
            if (typeof p.id !== 'number') p.id = -1;
        });

        this.props.maquinaItvs.maquinaItvs.forEach(p => {
            if (typeof p.id !== 'number') p.id = -1;
        });

        this.props.maquinaCentros.maquinaCentros.forEach(p => {
            if (typeof p.id !== 'number') p.id = -1;
        });


        const maquina = {
            id: this.props.detallesmaquina.maquinadetalles.id,
            descr: this.props.detallesmaquina.maquinadetalles.descr,
            matricula: this.props.detallesmaquina.maquinadetalles.matricula,
            iModeloMaquina: this.props.detallesmaquina.maquinadetalles.iModeloMaquina,
            fechaCompra: this.props.detallesmaquina.maquinadetalles.fechaCompra,
            fechaAlta: this.props.detallesmaquina.maquinadetalles.fechaAlta,
            fechaBaja: this.props.detallesmaquina.maquinadetalles.fechaBaja ? this.props.detallesmaquina.maquinadetalles.fechaBaja : '',
            regInterno: this.props.detallesmaquina.maquinadetalles.regInterno,
            activa: this.props.detallesmaquina.maquinadetalles.activa,
            comentarios: this.props.detallesmaquina.maquinadetalles.comentarios,
            regaloDirecto: this.props.detallesmaquina.maquinadetalles.regaloDirecto,
            centroId: this.props.detallesmaquina.maquinadetalles.centroId,
            contadores: this.props.maquinaContadores.maquinaContadores,
            incidencias: this.props.maquinaIncidencias.maquinaIncidencias,
            licencias: this.props.maquinalicencias.maquinalicencias,
            itVs: this.props.maquinaItvs.maquinaItvs,
            centros: this.props.maquinaCentros.maquinaCentros

        };

        if (this.checkFields(maquina)) {
            this.props.setSaveState(false);

            if (this.props.id === -1) {
                this.props.NewMaquinaDB(maquina, this.props.id, this.props.detallesmaquina.maquinadetalles.fechaAlta, () => { console.log(1000); this.props.navigate("mae_maquina") })
            }
            else {
                console.log(1001);
                this.props.updateDetallesMaquinaDB(maquina, this.props.id, () => { console.log(1500); this.props.navigate("mae_maquina") })
            };

        };
    };

    render() {

        const { classes } = this.props;

        return (
            <div>
                <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={this.props.backHandler}>Atrás</Button>
                <Button
                    disabled={this.props.detallesmaquina.isLoading || this.props.maquinaContadores.isLoading || this.props.maquinaIncidencias.isLoading ||
                        this.props.maquinalicencias.isLoading || this.props.maquinaItvs.isLoading || this.props.maquinaCentros.isLoading}
                    className={classes.buttonsBottom}
                    variant="contained"
                    color="primary"
                    onClick={() => this.updateHandler()}>
                    Guardar
                </Button>
            </div>
        );
    };

};

MaquinaActionButtons.propTypes = {
    //state
    id: PropTypes.number.isRequired,
    detallesmaquina: PropTypes.object.isRequired,
    maquinaContadores: PropTypes.object.isRequired,
    maquinaIncidencias: PropTypes.object.isRequired,
    maquinalicencias: PropTypes.object.isRequired,
    maquinaItvs: PropTypes.object.isRequired,
    maquinaCentros: PropTypes.object.isRequired,
    //dispatch
    updateDetallesMaquinaDB: PropTypes.func.isRequired,
    NewMaquinaDB: PropTypes.func.isRequired,
    navigate: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        detallesmaquina: state.maquinaDetalle,
        maquinaContadores: state.maquinaContadores,
        maquinaIncidencias: state.maquinaIncidencias,
        maquinalicencias: state.maquinalicencias,
        maquinaItvs: state.maquinaItvs,
        maquinaCentros: state.maquinaCentros
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateDetallesMaquinaDB,
        NewMaquinaDB,
        navigate,
        openDialog,
        setSaveState
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withStyles(styles, { withTheme: true })(MaquinaActionButtons)));